"use strict";

exports.__esModule = true;
exports.StyledDropdownMenu = exports.MenuListItemButton = exports.MenuListItem = exports.MenuList = exports.DropdownMenuOverlay = exports.DropdownMenuButton = exports.ButtonCaret = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const menuSlideIn = (0, _styledComponents.keyframes)`
    0% {
        opacity: 0;
        transform: scaleY(0.8);
        transform-origin: 0% 0%;
    }
    100% {
        opacity: 1;
        transform: scaleY(1);
        transform-origin: 0% 0%;
    }
`;
const menuSlideOut = (0, _styledComponents.keyframes)`
    0% {
        opacity: 1;
        transform: scaleY(1);
        transform-origin: 0% 0%;
    }
    100% {
        opacity: 0;
        transform: scaleY(0.8);
        transform-origin: 0% 0%;
    }
`;
const StyledDropdownMenu = _styledComponents.default.div`
    position: relative;
    display: block;
    font-size: ${props => props.theme.fontSizes[3]};
`;
exports.StyledDropdownMenu = StyledDropdownMenu;
const ButtonCaret = _styledComponents.default.div`
    position: absolute;
    left: auto;
    right: 0;
    color: ${({
  theme
}) => theme.colors.dropdownMenu.caret};

    svg {
        ${props => props.open && (0, _styledComponents.css)`
            transform: rotate(180deg);
        `}
    }
`;
exports.ButtonCaret = ButtonCaret;
const DropdownMenuButton = _styledComponents.default.button`
    position: relative;
    display: inline-block;
    padding: 3px 25px 3px 3px;
    font-size: ${props => props.theme.fontSizes[3]};
    border-radius: 0;
    border: none;
    border-bottom: 2px solid ${({
  theme
}) => theme.colors.dropdownMenu.border};
    color: ${({
  theme
}) => theme.colors.dropdownMenu.text};
    background-color: ${({
  theme
}) => theme.colors.dropdownMenu.background};
    text-align: left;
    height: 30px;
    width: 100%;
    cursor: pointer;

    &:focus {
        border-bottom: 2px solid ${({
  theme
}) => (0, _polished.lighten)(0.1, theme.colors.dropdownMenu.border)};

        ${({
  theme
}) => theme.name !== 'light' && theme.name !== 'dark' && (0, _styledComponents.css)`
            outline: 0;
        `};

        ${ButtonCaret} {
            color: ${({
  theme
}) => (0, _polished.lighten)(0.1, theme.colors.dropdownMenu.caret)};
        }
    }
`;
exports.DropdownMenuButton = DropdownMenuButton;
const DropdownMenuOverlay = _styledComponents.default.div`
    position: absolute;
    display: ${props => props.open ? 'block' : 'none'};
    width: 100%;
    z-index: 1000;

    &.slideIn {
        animation-name: ${menuSlideIn};
        animation-play-state: running;
        animation-duration: 250ms;
        animation-fill-mode: both;
        opacity: 0;
        animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    }

    &.slideOut {
        animation-name: ${menuSlideOut};
        animation-play-state: running;
        animation-duration: 250ms;
        animation-fill-mode: both;
        animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
        pointer-events: none;
    }

`;
exports.DropdownMenuOverlay = DropdownMenuOverlay;
const MenuList = _styledComponents.default.ul`
    display: inline-block;
    width: 100%;
    margin: 0;
    padding: 4px 0;
    text-align: left;
    list-style-type: none;
    background-color: ${({
  theme
}) => theme.colors.dropdownMenu.menu.background};
    background-clip: padding-box;
    border-radius: 4px;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    margin-top: 3px;
    
`;
exports.MenuList = MenuList;
const MenuListItem = _styledComponents.default.li`

`;
exports.MenuListItem = MenuListItem;
const MenuListItemButton = _styledComponents.default.button`
    width: 100%;
    margin: 0;
    padding: 5px 12px;
    color: ${({
  theme
}) => theme.colors.dropdownMenu.menuItem.text};
    background-color: transparent;
    font-weight: normal;
    font-size: ${props => props.theme.fontSizes[3]};
    line-height: 22px;
    text-align: left;
    white-space: nowrap;
    border: none;
    outline: 0;
    cursor: pointer;

    &:focus {
        outline: 0;
    }

    &:hover {
        color: ${({
  theme
}) => theme.colors.dropdownMenu.menuItem.hover.text};
        background-color: ${({
  theme
}) => theme.colors.dropdownMenu.menuItem.hover.background};
    }
`;
exports.MenuListItemButton = MenuListItemButton;